export const CONTENT_MODES = ["text", "video", "image"];

export function normalizeContentMode(mode, fallback = "text") {
  const normalized = String(mode ?? "").toLowerCase();
  if (CONTENT_MODES.includes(normalized)) {
    return normalized;
  }
  return fallback;
}

export function inferScenarioContentMode(data) {
  if (data?.sceneMode) {
    return normalizeContentMode(data.sceneMode, "video");
  }
  if (data?.hasVideo || data?.video === "X") {
    return "video";
  }
  if (data?.hasImage && data?.imagepath) {
    return "image";
  }
  if (data?.sceneText?.trim() || data?.questionText?.trim()) {
    return "text";
  }
  return "video";
}

export function buildScenarioModePatch(mode) {
  // Switching the displayed format should not discard content stored for the
  // other formats; scene deletion is responsible for removing that content.
  return { sceneMode: mode };
}

export function buildQuestionModePatch(mode) {
  const patch = { questionMode: mode };
  if (mode !== "video") {
    patch.hasVideo = false;
    patch.screenpath = "";
  }
  if (mode !== "text") {
    patch.questionText = "";
  }
  if (mode !== "image") {
    patch.hasImage = false;
    patch.imagepath = "";
  }
  return patch;
}

export function buildAnswerModePatch(mode) {
  const patch = { answerMode: mode };
  if (mode !== "video") {
    patch.hasVideo = false;
    patch.screenpath = "";
  }
  if (mode !== "text") {
    patch.answerText = "";
  }
  if (mode !== "image") {
    patch.hasImage = false;
    patch.imagepath = "";
  }
  return patch;
}
